import { connect } from 'react-redux';

import { Breadcrumbs, IBreadcrumbsStoreProps, IBreadcrumbsDispatchProps } from './Breadcrumbs';
import { IApplicationState } from '../../types/redux';
import { redirectPage } from '../../actions/helper';

function mapStateToProps(state: IApplicationState): IBreadcrumbsStoreProps {
  return {
    breadcrumbs: state.helper && state.helper.breadcrumbs || [],
    page: state.helper && state.helper.page || 'main',
  };
}

function mapDispatchToProps(): IBreadcrumbsDispatchProps {
  return {
    redirectPage,
  };
}

export const BreadcrumbsContainer = connect<IBreadcrumbsStoreProps, IBreadcrumbsDispatchProps>
  (mapStateToProps, mapDispatchToProps)(Breadcrumbs);
